// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__jMbW6","chatContainer":"Header_chatContainer__2KlWm","fileBlock":"Header_fileBlock__1wpz4"};